export const renderLyPopoverV4 = (popoverId, title, contentHtml) => {
  return `
    <ly-popover-v4 class="ly-popover-v4">
      <input type="checkbox" class="ly-popover-v4-checkbox ly-hide" id="${popoverId}">
      <div class="ly-popover-v4-inner-container">
        <label class="ly-popover-v4-close-label" for="${popoverId}">
          <span class="svg-wrapper">
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M10.8571 0.858803L0.857673 10.8572M0.857117 0.857178L10.8566 10.8556" stroke="currentColor" stroke-width="1.71429" stroke-linecap="round"/>
            </svg>
          </span>
        </label>
        <div class="ly-popover-v4-inner-wrapper">
          <div class="ly-popover-v4-inner-header">${title}</div>
          <div class="ly-popover-v4-inner-body">
            <template>
              ${contentHtml}
            </template>
          </div>
        </div>
      </div>
    </ly-popover-v4>
    `
}

export const renderIndicatorItems = (items) => {
  return `
  <div class="ly-indicators-items">
      ${items.map(_ => `<span class="ly-indicators-item" data-carousel-indicator></span>`).join('')}
  </div>
  `
}

export const renderLyCtrlButtons = (type) => {
  return `
  <div class="ly-ctrl-buttons type-${type}">
    <button class="ctrl-btn prev" data-carousel-button name="prev">
      <span class="svg-wrapper">
        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
            <path d="M316.28 514.711L699.53 131.46c17.574-17.573 17.574-46.066 0-63.64-17.573-17.573-46.066-17.573-63.64 0L189 514.712l446.891 446.892c17.574 17.573 46.067 17.573 63.64 0 17.574-17.574 17.574-46.066 0-63.64L316.28 514.711z" />
        </svg>
      </span>
    </button>
    <button class="ctrl-btn next" data-carousel-button name="next">
      <span class="svg-wrapper">
        <svg viewBox="0 0 1024 1024" xmlns="http://www.w3.org/2000/svg">
            <path d="M766.504 515.072L383.252 131.82c-17.574-17.574-17.574-46.066 0-63.64 17.573-17.573 46.066-17.573 63.64 0l446.891 446.892-446.892 446.891c-17.573 17.574-46.066 17.574-63.64 0-17.573-17.573-17.573-46.066 0-63.64l383.253-383.251z" />
        </svg>
      </span>
    </button>
  </div>
  `
}